import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Button, Image } from 'react-bootstrap';
import uploadedImage from '../../../../../images/cr-logo-new.png';
import Api from '../../../../Global/Modules/Api'

class LidGeneralData extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            member: {
            },
            header: {
            }
        }
    }

    handleClick(e) {
        var url = "api/members/" + this.props.id + "/pdf";
        Api.GetApiDownload(url)
    }

    componentWillMount() {
        var url = "api/members/" + this.props.id;
        Api.GetApi(url).then(data => {
            this.setState({ member: data })
            this.setState({ header: data.header })
        });
    }
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/auth/member/${id}`
        if (window.confirm('Weet u zeker dat u dit lid wilt verwijderen??')) {
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                window.location.href = '/admin/leden'
            })
        }
    }
    render() {
        return (
            <div>
                <p>{this.state.member.company}</p>
                <hr />
                <Row>
                    <Col md={9} sm={12}>
                        <Row>
                            <Col sm={4} xs={12}>
                                <Image src={uploadedImage} responsive width={200} height={200} />
                            </Col>
                            <Col sm={3} xs={6} className="LidGeneralDataLeft">
                                <p>Lidnummer</p>
                                <p>Naam</p>
                                <p>Status</p>
                                <p>Kennis</p>
                                <p>Permanente kennis</p>
                                <p>Totaal Ke's</p>
                                <p title="Gemiddeld aantal uren per jaar">Gem. aantal uren per jaar</p>
                                <p>Ee's acc</p>
                                <p>Ee's ingevoerd</p>
                                <p>Ingeschreven sinds</p>
                            </Col>
                            <Col sm={5} xs={6} className="LidGeneralDataRight">
                                <p>{this.state.member.idOld}&nbsp;</p>
                                <p>{this.state.header.name}&nbsp;</p>
                                <p>{this.state.header.status}&nbsp;</p>
                                <p>{this.state.member.ke}&nbsp;</p>
                                <p>{this.state.member.pe}&nbsp;</p>
                                <p className="bold">{this.state.member.ke + this.state.member.pe}&nbsp;</p>
                                <p>{this.state.member.hoursPerYear}</p>
                                <p>{this.state.member.eeImplemented}&nbsp;</p>
                                <p>{this.state.member.ee}&nbsp;</p>
                                <p>{this.state.member.dateRegister == "0001-01-01T00:00:00" ? "" : Api.formatDate(this.state.member.dateRegister)}&nbsp;</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} sm={6}>
                        <Button block onClick={this.handleClick}>
                            Genereer PDF rapport
                        </Button>
                        <LinkContainer to={"/admin/leden/lid/gegevens/password/" + this.props.id}>
                            <Button block >
                                Wachtwoord wijzigen
                            </Button>
                        </LinkContainer>
                        <Button className="danger" block onClick={this.handleDelete(this.state.member.applicationUserId)}>
                            Verwijder dit lid
                        </Button>
                    </Col>
                </Row>
                <hr />
            </div>
        );
    }
}

export default LidGeneralData;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/LidGeneralData.js